import moment from 'moment';
// Type-only: a value import drags the VoucherSummary component into every bundle touching pricing.
import type { OrderCustomDetails } from './steps/VoucherSummary';
import { HolidayCalendar } from '../api';
import { getHoliday } from '../utils/getHoliday';

export enum PluginType {
  WEEKEND_AND_ISRAELI_HOLIDAYS = 'weekendAndIsraeliHolidays',
  REE_ESCORTS = 'freeEscorts',
}

export const getPluginData = (plugins: any, type: any) => {
  return plugins?.find((p: any) => p.type === type);
};
// moment's day(): 0 = Sunday ... 6 = Saturday.
const WEEKEND_DAYS: Record<HolidayCalendar, number[]> = {
  [HolidayCalendar.ISR]: [5, 6], // Friday, Saturday
  [HolidayCalendar.US]: [0, 6], // Sunday, Saturday
};

const isWeekendOrHoliday = (date: any, holidayCalendar: HolidayCalendar = HolidayCalendar.ISR): boolean => {
  const weekendDays = WEEKEND_DAYS[holidayCalendar] || WEEKEND_DAYS[HolidayCalendar.ISR];
  return weekendDays.includes(moment(date).day()) || !!getHoliday(holidayCalendar, date);
};

const handleWeekendAndIsraeliHolidaysPlugin = (
  plugins: any,
  price: number,
  date: any,
  shouldUseweekendPlugin?: boolean,
  holidayCalendar?: HolidayCalendar,
) => {
  // shouldUseweekendPlugin is for vouchers that include weekend.
  const pluginData = getPluginData(plugins, PluginType.WEEKEND_AND_ISRAELI_HOLIDAYS);
  if (!pluginData) {
    return price;
  }
  if (shouldUseweekendPlugin || (date && isWeekendOrHoliday(date, holidayCalendar))) {
    return Math.floor(price * pluginData.multiply);
  }

  return price;
};

const customDetailsHasPlugin = (customDetails: OrderCustomDetails, pluginType: PluginType) => {
  return customDetails[pluginType] === true;
};
const PluginUtils = {
  getPluginData,
  handleWeekendAndIsraeliHolidaysPlugin,
  customDetailsHasPlugin,
  isWeekendOrHoliday,
};

export default PluginUtils;
